import { render, staticRenderFns } from "./RootPage.vue?vue&type=template&id=025f7f04&scoped=true&"
import script from "./RootPage.vue?vue&type=script&lang=js&"
export * from "./RootPage.vue?vue&type=script&lang=js&"
import style0 from "./RootPage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RootPage.vue?vue&type=style&index=1&id=025f7f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025f7f04",
  null
  
)

export default component.exports